import PropTypes from 'prop-types';

// Uses ICU message syntax for proper i18n grammar across languages.
// Each duration unit has its own message ID so translators can control word order.
const DisplayLabel = ({
  flag, label, value, duration, intl,
}) => {
  const defaultMessages = {
    minutes: 'Last {val} minutes',
    hours: 'Last {val} hours',
    days: 'Last {val} days',
  };

  return flag ? label : intl.formatMessage(
    { id: `Admin.Log.Viewer.last.${duration}`, defaultMessage: defaultMessages[duration] },
    { val: value },
  );
};

DisplayLabel.propType = {
  value: PropTypes.number.isRequired,
  duration: PropTypes.string.isRequired,
  flag: PropTypes.bool,
  label: PropTypes.string,
};

DisplayLabel.defaultProps = {
  flag: false,
};

export default DisplayLabel;
